import { User } from "shared/interfaces/user";
import styles from "../../styles/table.module.scss";

export const Email = (props: { user: User }) => {
  return (
    <td className={styles.tableCell}>{`${props.user.email.substr(0, 23)}`}</td>
  );
};
